<template>
  <div class="admin-default">
    <h2 class="title">Welcome to Fabbi ECS!</h2>
  </div>
</template>

<script>
export default {
  name: "AdminDefault",
  metaInfo() {
    return {
      title: this.$t("page_title.page_welcome"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {},
  data() {
    return {};
  },
  created() {
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.admin-default {
  .title {
    font-weight: 700;
    color: #3d4cdc;
  }
}
</style>